export default __webpack_public_path__ + "static/media/Cairo-Medium.733b9038.ttf";